import { AfterViewInit, Directive, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IgxGridComponent } from '@infragistics/igniteui-angular';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { PagedGridComponent } from '../components/paged-grid/paged-grid.component';
import { GridSettingsService } from '../services/grid-settings.service';

@Directive({
    selector: '[slGridState]',
    standalone: false
})
export class GridStateDirective implements AfterViewInit, OnInit, OnDestroy {
    @Input('slGridState') name: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    @Input() preventSave = false;

    private routerSubscription?: Subscription;
    private isAlreadySaved = false;

    private readonly grid = inject(IgxGridComponent, { host: true, self: true });
    private readonly pagedGrid = inject(PagedGridComponent, { host: true });
    private readonly router = inject(Router);
    private readonly gridSettingsService = inject(GridSettingsService);

    constructor() {
        window.addEventListener('beforeunload', () => this.doBeforeDestroy());
    }

    ngOnInit(): void {
        this.routerSubscription = this.router.events.pipe(take(1)).subscribe(() => this.doBeforeDestroy(true));
    }

    ngAfterViewInit(): void {
        this.gridSettingsService.load(this.name, this.pagedGrid).subscribe(hadSettings => {
            if (hadSettings) {
                this.grid.cdr.detectChanges();
            }
        });
    }

    ngOnDestroy(): void {
        this.doBeforeDestroy();
    }

    private doBeforeDestroy(fromInit = false): void {
        if (!this.gridSettingsService.shouldPreventOnBeforeDestroySave && !this.preventSave && !this.isAlreadySaved) {
            this.isAlreadySaved = !fromInit;
            this.gridSettingsService.save(this.name, this.grid);
        }

        if (!!this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }
}
